import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading } from "uitk-react-text";

import { JumplinksTitleProps } from "../typings";

const JumplinksTitle = (props: JumplinksTitleProps) => {
  const { model, context } = props;
  const { title } = model;
  const { location } = context.searchContext;
  const locationName = location.localizedName || location.defaultName || location.name;

  if (!(title || locationName)) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <div className="all-b-margin-two">
      <UitkHeading level={2} size={500}>
        {title || formatText("jumplinks.discover", locationName)}
      </UitkHeading>
    </div>
  );
};

export default JumplinksTitle;
